export const AllShapes = {
    SQUARE: 'square',
    CIRCLE: 'circle',
};

export const DOT_SHAPES = [
    AllShapes.SQUARE,
    AllShapes.CIRCLE,
];
